import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', {
  // persist: true,
  state: () => ({
    usuario: null,
  }),
  actions: {
    async login(usuario) {
      this.usuario = usuario;
    },
    logout() {
      this.usuario = null;
    },
  },
});
